import Swiper, { Autoplay, Navigation, Scrollbar } from 'swiper';
// import { swiperObserver } from '../utils/swiper.utils.js';
import { swiperOnResize } from '../utils/swiperOnResize.utils.js';


let togglesSwiperWr = document.querySelectorAll('.toggles-swiper-wr');
togglesSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let items = el.querySelectorAll('.swiper-slide');

    const hasScrollbar = swiperEl.hasAttribute('data-scrollbar');
    let scrollbarEl = el?.querySelector('.swiper-scrollbar');

    if (!scrollbarEl && hasScrollbar) {
      scrollbarEl = document.createElement('div');
      scrollbarEl.classList.add('swiper-scrollbar');
      swiperEl.appendChild(scrollbarEl);
    }

    let swiper = new Swiper(swiperEl, {
      modules: [Scrollbar],
      slidesPerView: 'auto',
      freeMode: true,
      slideToClickedSlide: true,
      spaceBetween: 8,
      breakpoints: {},
      scrollbar: hasScrollbar ? {
        el: el.querySelector('.swiper-scrollbar'),
        draggable: true,
      }
      : false,
    });

    items.forEach((item) => {
      item.addEventListener('click', (e) => {
        swiper.slideTo(Array.from(items).indexOf(item));
      });
    })
  }
});
